import { createApp, h } from 'vue'
import { InertiaProgress } from '@inertiajs/progress'
import { createInertiaApp } from '@inertiajs/inertia-vue3'
import moment from 'moment'
// import { useUserStore } from '@/stores/user'
// import axios from 'axios'

// Components
import Accordion from './Shared/Accordion/Accordion'
import AccordionItem from './Shared/Accordion/AccordionItem'

// Test
import TestItem from './Shared/Test/TestItem'
import TestResult from './Shared/Test/TestResult'
// Exam
import ExamItem from './Shared/Exam/ExamItem'
import Exam from './Shared/Exam/Exam'
import ExamTimer from './Shared/Exam/ExamTimer'
import Selfcontrol from './Shared/Exam/Selfcontrol'
import FreetextSelfcheck from './Shared/Exam/FreetextSelfcheck'
// Questions
import QuestionTimer from './Shared/Questions/QuestionTimer'
import Questions from './Shared/Questions/Questions'
import Question from './Shared/Questions/Question'
import QuestionIndex from './Shared/Questions/QuestionIndex'
import SingleChoiceQuestion from './Shared/Questions/SingleChoiceQuestion'
import MultipleChoiceQuestion from './Shared/Questions/MultipleChoiceQuestion'
import TextQuestion from './Shared/Questions/TextQuestion'
// Mistakes
import MistakeItem from './Shared/Mistakes/MistakeItem'
// import MistakeModal from './Shared/Mistakes/MistakeModal'
// Admin
import QuestionListItem from './Shared/Admin/QuestionListItem'
import QuestionChoicesItem from './Shared/Admin/QuestionChoicesItem'


import Alert from './Shared/Components/Alert'

import AppBanner from './Shared/Navigation/InstallAppBanner'

window.$axios = require('axios');

// eslint-disable-next-line no-undef
window._ = require('lodash')
window.trans = (string) => _.get(window.i18n, string)

InertiaProgress.init()

createInertiaApp({
  resolve: name => require(`./Pages/${name}`).default,
  title: title => title ? `${title} - DGVT-Prüfungstrainer` : 'DGVT-Prüfungstrainer',
  setup({ el, App, props, plugin }) {
    createApp({
      created() {
        // App.prototype.trans = string => _.get(window.i18n, string);
      },
      render: () => h(App, props),
    })
      .use(plugin)
      .use(moment)
      .component('Accordion', Accordion)
      .component('AccordionItem', AccordionItem)
      .component('TestItem', TestItem)
      .component('TestResult', TestResult)
      .component('ExamItem', ExamItem)
      .component('Exam', Exam)
      .component('Questions', Questions)
      .component('Question', Question)
      .component('QuestionIndex', QuestionIndex)
      .component('SingleChoiceQuestion', SingleChoiceQuestion)
      .component('MultipleChoiceQuestion', MultipleChoiceQuestion)
      .component('TextQuestion', TextQuestion)
      .component('ExamTimer', ExamTimer)
      .component('QuestionTimer', QuestionTimer)
      .component('Selfcontrol', Selfcontrol)
      .component('FreetextSelfcheck', FreetextSelfcheck)
      .component('Alert', Alert)
      .component('QuestionListItem', QuestionListItem)
      .component('QuestionChoicesItem', QuestionChoicesItem)
      .component('AppBanner', AppBanner)
      .component('MistakeItem', MistakeItem)
      // .component('MistakeModal', MistakeModal)
      .mixin(require('./translations'))
      .mount(el)
  }
})

